import React from 'react';

const links = [
  { id: 'wallets',  label: '👛 Wallets'  },
  { id: 'rules',    label: '⚙️ Rules'    },
  { id: 'activity', label: '📡 Activity' },
  { id: 'settings', label: '⚙ Settings' },
];

export const Navbar = ({ active, setActive, health, user }) => (
  <nav style={S.nav}>
    <div style={S.brand}>
      <span style={S.logo}>◎</span>
      <span style={S.title}>SOL HUB</span>
      <span style={{ ...S.pill, background: health ? '#00ff8820' : '#ff4d6a20',
        color: health ? '#00ff88' : '#ff4d6a', borderColor: health ? '#00ff8840' : '#ff4d6a40' }}>
        {health ? '● LIVE' : '● OFFLINE'}
      </span>
    </div>
    <div style={S.links}>
      {links.map(l => (
        <button key={l.id} onClick={() => setActive(l.id)}
          style={{ ...S.link, ...(active === l.id ? S.linkActive : {}) }}>
          {l.label}
        </button>
      ))}
      {user && <span style={S.userBadge}>👤 {user.name}</span>}
    </div>
  </nav>
);

const S = {
  nav:       { display:'flex', alignItems:'center', justifyContent:'space-between',
               padding:'0 32px', height:60, background:'rgba(8,11,16,0.92)',
               backdropFilter:'blur(12px)', borderBottom:'1px solid #1e2d3d',
               position:'sticky', top:0, zIndex:100 },
  brand:     { display:'flex', alignItems:'center', gap:10 },
  logo:      { fontSize:22, color:'#00ff88', lineHeight:1 },
  title:     { fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:16, letterSpacing:'0.12em' },
  pill:      { fontSize:10, fontWeight:700, letterSpacing:'0.08em', padding:'3px 8px',
               borderRadius:20, border:'1px solid', fontFamily:"'Space Mono',monospace" },
  links:     { display:'flex', alignItems:'center', gap:4 },
  link:      { background:'transparent', color:'#7a94b0', padding:'6px 16px',
               borderRadius:6, fontSize:13, fontWeight:600, border:'none', cursor:'pointer' },
  linkActive:{ background:'#00ff8815', color:'#00ff88' },
  userBadge: { fontSize:12, color:'#7a94b0', marginLeft:8,
               fontFamily:"'Space Mono',monospace" },
};
